module.exports = __webpack_public_path__ + "img/icon-cross.92b85670.svg";